<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Randolph Field</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-head" id="Ack">A<span class="small">CKNOWLEDGMENTS</span></p>
<p class="para1">The beauty of the buildings on Randolph Field and its unique shape made it a well-photographed subject.</p>
<p class="para">The author would like to acknowledge the assistance of the staff of the Air Force Education and Training Command (AETC) Office of History and Research, especially command historian Gary D. Boyd and art program and museum curator Robert V. Crawford. Their cooperation in allowing me access to their archives was essential to the compilation of this book.</p>
<p class="para">All photographs herein are from the United States Air Force, courtesy of the AETC Office of History and Research.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgments.vue?95ca44dc